import { LoginScreen } from "@/modules/login/Login.tsx";

export default function LoginsRoot() {
    return <LoginScreen />;
}
